<template>
 <div>
   <el-row class="dialog-form" v-if="infoDetail">
     <el-col class="g-basic-info">
      <div class="g-service-type">{{infoDetail.noteState|noteState}}</div>
        <el-row>
          <el-col :span="12"><p>票据类型：{{infoDetail.noteType|noteType}}</p></el-col>
        </el-row>
        <el-row>
          <el-col :span="12"><p>申请提交时间：{{new Date(infoDetail.noteCreateTime).format('yyyy-MM-dd hh:mm:ss')}}</p></el-col>
        </el-row>
        <div class="g-col-line"></div>
        <el-row>
          <el-col :span="12"><p>申请企业：{{infoDetail.noteCompanyName|empty}}</p></el-col>
          <el-col :span="12"><p>申请人：{{noteCreateName|empty}}</p></el-col>
        </el-row>
        <el-row>
          <el-col :span="24"><p>关联合同：{{infoDetail.noteContractInfo?infoDetail.noteContractInfo:'暂无数据'}}</p></el-col>
        </el-row>
        <el-row>
          <el-col :span="24"><p>关联账单：{{infoDetail.noteBillInfo?infoDetail.noteBillInfo:'暂无数据'}}</p></el-col>
        </el-row>
        <el-row>
          <el-col :span="24"><p>情况描述：{{infoDetail.noteDescription|empty}}</p></el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="display:flex;">
            <span style="line-height:30px;">凭证文件：</span>
            <ul class="fileList" v-if="infoDetail.noteVoucherFile">
              <li v-for="(file,index) in JSON.parse(infoDetail.noteVoucherFile)" :key="index">
                <span class="ellipsis">{{file.fileName}}</span>
                <el-button size="mini" type="primary" @click="openFile(file.exportFile)">预览</el-button>
                <el-button size="mini" type="primary" @click="downLoad(file)">下载</el-button>
              </li>
            </ul>
          </el-col>
        </el-row>
       <div class="g-col-line"></div>
       <el-row v-if="infoDetail.noteType != 3">
         <el-col :span="12"><p>纳税人识别号：{{infoDetail.noteTaxpayer|empty}}</p></el-col>
         <el-col :span="12"><p>地址：{{infoDetail.noteAddress|empty}}</p></el-col>
       </el-row>
       <el-row v-if="infoDetail.noteType != 3">
         <el-col :span="12"><p>电话：{{infoDetail.notePhone|empty}}</p></el-col>
         <el-col :span="12"><p>开户行：{{infoDetail.noteBank|empty}}</p></el-col>
       </el-row>
       <el-row v-if="infoDetail.noteType != 3">
         <el-col :span="12"><p>帐号：{{infoDetail.noteAccount|empty}}</p></el-col>
       </el-row>
     </el-col>
   </el-row>
 </div>
</template>

<script>
  import * as global from "../config/mUtils";
  import * as getData from "../service/getData";
  export default {
    data() {
      return {
        imgUrl: '',
        lookBigImgDialog: false,
        fileList:[],
      };
    },
    created() {
    },
    mounted() {
    },
    props: ['infoDetail','noteCreateName'],
    computed: {},
    methods: {
      openFile (url) {
        window.open(url)
      },
      downLoad(file){
        window.open('/company/download/downloadWorkflowFileUseName?fileName='+file.fileName+'&fileUrl='+file.exportFile)
      },
    },
    components: {},
    watch: {}
  };
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';
  .g-flexbox{
    display: flex;
    .p-label{
      flex: none;
    }
  }
  .g-service-type{
    top: 0;
  }
  .dialog-form{
    box-shadow:0px 3px 10px 0px rgba(0,14,26,0.04);
  }
  .fileList{
    li{
      margin-bottom: 10px;
    }
  }

</style>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/bill-order-info.vue